import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { BrandedSimpleLayoutComponent } from './components/branded-simple-layout/branded-simple-layout.component';
import { UIModule } from '@referrals/shared/ui/ui.module';
import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { MaterialModule } from '@referrals/shared/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [BrandedSimpleLayoutComponent, AdminLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    UIModule,
    MaterialModule,
    FlexLayoutModule,
  ],
  exports: [BrandedSimpleLayoutComponent],
})
export class LayoutsModule {}
